// extracted by mini-css-extract-plugin
module.exports = {"skip":"style_skip__erJ69","spin":"style_spin__0OgmM"};